import React, { useEffect } from "react";
import Header from "./Header";
import "./LenderLoadingScreen.css";
import loadinglender from "../assets/images/loadinglender.gif";
import stepsGif from "../assets/images/stepsGif.gif";

const LenderLoadingScreen = () => {

  // Prevent body scroll when loader is active
  useEffect(() => {
    // Save original overflow style
    const originalOverflow = document.body.style.overflow;
    const originalOverflowY = document.documentElement.style.overflowY;
    
    // Disable scrolling
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflowY = 'hidden';
    
    return () => {
      // Restore original overflow style when component unmounts
      document.body.style.overflow = originalOverflow;
      document.documentElement.style.overflowY = originalOverflowY;
    };
  }, []);

  return (
    <div className="lender-loading-overlay">
      <div className="lender-loading-container">
        {/* Header within the container */}
        <Header disableScrollHide={true} />
        
        {/* Main Content */}
        <div className="main-content main-content-lender">
          <div className="hero-section">
            <div className="hero-text">
              <h1 className="hero-title lender-title">Please wait ...</h1>
            </div>
            <div className="hero-icon">
              <img className="lenderImg" src={loadinglender} alt="loadinglender" />
            </div>
          </div>
          <div className="hero-section herosubtitle-message">
            <div className="hero-text">
              <h1 className="hero-subtitle lender-subTitle">
              Make your interest costs zero in 3 easy steps
              </h1>
               <div className="flex justify-center items-center w-full mt-[10px]">
  {/* <img
    className="w-full sm:w-[1000px] max-w-[880px]"
    src={stepsGif}
    alt="stepsGif"
  /> */}
  <img
  className="w-full sm:w-[1200px] max-w-[1200px]"
  src={stepsGif}
  alt="stepsGif"
/>

</div>
            </div>
            

          </div>

          {/* <div className="hero-section hero-subtitle-message">
            <div className="hero-text">
              <h1 className="hero-subtitle lenderSubTitle">
              Make your interest costs zero in 3 easy steps
              </h1>
            </div>
          </div> */}
          

         

        </div>
   

      </div>
    </div>
  );
};

export default LenderLoadingScreen;
